import AdvertiseBanner from "../AdvertiseBanner/AdvertiseBanner";
import ProductCategory from "../ProductCategory/ProductCategory";
import "./HomePage.css";

function HomePage() {
  return (
    <div>
      {/* Body */}
      <div className="app-container">
        {/* Content Wrapper */}
        <div className="content-wrapper">
          <AdvertiseBanner />
          <ProductCategory />
        </div>
      </div>
    </div>
  );
}

export default HomePage;
